import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Payments from '../../Common/Payment';
import ErrorMessage from '../../Common/ErrorMessage';

class Payment extends Component {

  render() {
    const { quotation, vehicles, economic } = this.props;

    let codSubramo = '1';
    switch (vehicles.vehicleType) {
      case 'auto':    /*Default*/       break; 
      case 'omnibus': codSubramo = '2'; break;
      case 'camion':  codSubramo = '2'; break;
      case 'moto':    /*Default*/       break;
      default:        /*Default*/       break;
    }

    const quoterData = {
      CodSubramo: codSubramo,
      RateCode: quotation.rateCode,
      DeductibleQuantity: vehicles.hasAssistance ? quotation.deductibleQuantity : quotation.deductibleQuantityOpt,
      MobilityCosts: false,
      MechanicalAssistance: economic ? false : vehicles.hasAssistance,
      ZeroKm: vehicles.is0Km,
      Plate: vehicles.carMatricula,
      Engine: vehicles.carMotor,
      Chassis: vehicles.carChassis,
    };

    if(quotation.errorMessage){
      return (
        <ErrorMessage tryAgain={false}
          errorText={quotation.errorMessage} />
      );
    }
    return (
      <div>
        <Payments
          currency='UYU'
          quoterData={quoterData}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    quotation: state.quotation,
    vehicles: state.vehicles,
    economic: state.vehicles.economic
  };
};

export default connect(mapStateToProps, null)(Payment);